import { gql } from '@apollo/client';

export const GET_FORM_BY_ID = gql`
  query FORM_SERVICE_getFormById($id: ID!, $bc: Map) {
    getFormById(id: $id, bc: $bc) {
      id
      formTitle
      description
      sections {
        title
        layout
        showWhen
      }
    }
  }
`;

export const GET_BROWSING_PORTFOLIO_CONFIG_FORM = gql`
  query FORM_SERVICE_getBrowsingConfigFormByPortfolioId($portfolioId: String!, $effectiveDate: String!) {
    getBrowsingConfigFormByPortfolioId(portfolioId: $portfolioId, effectiveDate: $effectiveDate) {
      id
      formTitle
      sections {
        title
        layout
        showWhen
      }
    }
  }
`;
